import { render, staticRenderFns } from "./TournamentEmbedView.vue?vue&type=template&id=26739976&scoped=true"
import script from "./TournamentEmbedView.vue?vue&type=script&lang=js"
export * from "./TournamentEmbedView.vue?vue&type=script&lang=js"
import style0 from "./TournamentEmbedView.vue?vue&type=style&index=0&id=26739976&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26739976",
  null
  
)

export default component.exports